import { Button, Typography } from '@grammarly/badger-ui'

import { IconClose } from '../../../../ui-lib/icons/close'

import styles from './not-enough-text-alert.module.scss'

const { C5 } = Typography

interface TextCheckerNotEnoughTextAlertProps {
  onUseSampleText: () => void
  onClose: () => void
}

export const TextCheckerNotEnoughTextAlert = (props: TextCheckerNotEnoughTextAlertProps) => {
  return (
    <div className={styles.notEnoughTextAlert} role="alert">
      <C5 as="div">
        Not enough text to check!
        <br />
        Add more words or{' '}
        <Button
          className={styles.sampleTextButton}
          padding="none"
          onClick={() => {
            props.onUseSampleText()
            props.onClose()
          }}
        >
          use our sample text
        </Button>{' '}
        to see Grammarly’s feedback
      </C5>
      <Button className={styles.closeButton} onClick={props.onClose} padding="none" aria-label="Close">
        <IconClose aria-hidden="true" />
      </Button>
    </div>
  )
}
